<div class="edp-input-toogle edp-form">
    <div class="form-switch mb-4">
        <input
            [checked]="toogleValue"
            (change)="onChange($event)"
            [value]="toogleValue"
            type="checkbox"
            class="custom-control-input"
            [id]="'push-opt-out' + sufix"
        />
        <label class="form-switch-label d-flex flex-column" [for]="'push-opt-out' + sufix">
            <span *ngIf="title" class="edp-input-toogle-title" [innerHTML]="title | translate"></span>
            <span *ngIf="!!description" class="description" class="edp-input-toogle-description" [innerHTML]="description | translate"></span>
        </label>
    </div>
</div>